<script lang="ts" setup>
import PhoneButton from '@/components/PhoneButton.vue';
import WebsiteButton from '@/components/WebsiteButton.vue';
import PostalAddress from '@/components/PostalAddress.vue';
import { useI18n } from 'vue-i18n';
import { primaryPhoneNumber } from '@/utilities';
import type { GetProjectDetailsProjectResponse } from '@/api';

defineProps<{
  project: GetProjectDetailsProjectResponse;
}>();

const { t } = useI18n();
</script>

<template>
  <section class="flex h-full flex-col">
    <h2 class="2xs:text-lg xs:text-xl mb-2 text-base font-semibold">{{ t('views.project.contact.header') }}</h2>
    <div class="flex flex-1 flex-col gap-4 rounded-md border-2 border-gray-200 bg-gray-50 p-4">
      <div v-if="project.logo && project.logo.length > 0">
        <template v-if="project.isPaid && project.website && project.website.length > 0">
          <a :href="project.website" rel="noopener" target="_blank">
            <img :alt="project.name" :src="project.logo.resizedToSmall(true)" class="h-16" />
          </a>
        </template>
        <template v-else>
          <img :alt="project.name" :src="project.logo.resizedToSmall(true)" class="h-16" />
        </template>
      </div>
      <h5 class="font-semibold tracking-tight">{{ project.name }}</h5>
      <PostalAddress :address="project.address" :address-line1-title="project.addressLine1Title" :address-line2-title="project.addressLine2Title" class="text-sm" />
      <!-- Une colonne plutôt qu'une rangée répartie : à deux personnes-ressources, l'ancienne
           disposition renvoyait les boutons aux deux extrémités de l'encadré. -->
      <div v-if="project.isPaid" class="mt-auto flex flex-col items-start gap-2">
        <WebsiteButton :target-id="project.id" :url="project.website" target="project" variant="primary" />
        <PhoneButton v-for="(contact, index) in project.contacts" :key="index" :name="contact.name" :phone-number="primaryPhoneNumber(contact)" :target-id="project.id" target="project" />
      </div>
    </div>
  </section>
</template>

<style lang="css" scoped></style>
